'use client';

import { useSyncExternalStore } from 'react';
import { Content } from '@packages/cms-components/src/components/CmsContent/Content';
import type { Audiences, CmsData } from '@packages/cms-components/interfaces';
import { filterParagraphs } from '@packages/cms-components/src/utils/filterParagraphs';
import {
  getAllAudiences,
  getEcStateFromParams,
} from '@packages/cms-components/src/utils/audiences';
import { previewSettingsStore, previewSettingsServerSnapshot } from './previewSettingsStore';

const filteredContent = (
  content: CmsData,
  testDate?: string | string[],
  audiences?: Audiences[],
) => ({
  ...content,
  paragraph: filterParagraphs(content.paragraph, testDate, audiences),
});

export const Preview = ({ content, token }: { content: CmsData; token: string | null }) => {
  const settings = useSyncExternalStore(
    previewSettingsStore.subscribe,
    previewSettingsStore.get,
    previewSettingsServerSnapshot,
  );

  const audiences = getAllAudiences(getEcStateFromParams(settings.audiences ?? ''));
  const testDate = settings.testDate ?? '';
  const showAll = settings.showAll === 'true';

  const hasServiceMenu = content.menu === 'service' && content.menuFull;

  return (
    <Content
      data={showAll ? content : filteredContent(content, testDate, audiences)}
      menuData={hasServiceMenu ? content.menuFull : undefined}
      token={token ?? undefined}
    />
  );
};
